



















































import {Vue, Component} from 'vue-property-decorator';
import {ProductDeliveryTemplate, ProductsDetailUrl, GetDeliveryTemplateByNo} from 'supporter';
import ItemTable from '@/components/common/ItemTable.vue';
import {i18nInObjectList} from '@/utils/i18n';
import {popupResize} from '@/utils/ncp';
import { addProductDetailUrlPreview } from '@/utils/formatUtils';
import { convertProductUri } from '@/utils/commonUtils';
@Component({
  components: {ItemTable}
})
export default class DeliveryConditionDetailPopup extends Vue {
  private productsDetailUrls: ProductsDetailUrl[] = [];
  private products: ProductDeliveryTemplate[] = [];
  private template: GetDeliveryTemplateByNo | null = null;
  private deliveryTemplateNo = '';
  private gridProps = {
    header: {
      height: 33
    },
    options: {
      columnOptions: {
        minWidth: 50,
        resizable: true
      },
      minRowHeight: 30,
      rowHeight: 30,
      afterInitialRequest: true,
      useClientSort: false,
      pageOptions: {
        visiblePages: 5,
        perPage: 15,
        page: 1,
        totalCount: 0
      }
    },
    columns: [
      {
        header: 'DELIVERY_GROUP_TEMPLATE_PRODUCT_NO',
        name: 'productNo',
        align: 'center',
        width: 125,
        formatter: (obj: any) => {
          const url = this.getProductDetailUrl(obj.row.mallNo as number);
          const uri = convertProductUri(url, obj.value);
          return url ? `<a target="_blank" href="${uri}" >${obj.value}</a>` : obj.value;
        }
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_PRODUCT_NAME',
        name: 'productName',
        align: 'left',
        width: 245,
        ellipsis: true
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_MANAGEMENT_CODE',
        name: 'managementCode',
        align: 'center',
        width: 125
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_SALE_STATUS',
        name: 'saleStatus',
        align: 'center',
        width: 145,
        formatter: function ({row, value}: any) {
          const saleStatusType = row['saleStatus'];
          const saleSettingStatus = row['saleSettingStatus'];
          if (saleSettingStatus === 'PROHIBITION_SALE') {
            return '-';
          }
          if (saleStatusType === 'PRE_APPROVAL_STATUS') {
            return window.$t('PRODUCT_OPTION_BEFORE_ADMIT');
          } else if (saleStatusType === 'ON_PRE_SALE') {
            return window.$t('PRODUCT_OPTION_PRE_SELLING');
          } else if (saleStatusType === 'WAITING_SALE') {
            return window.$t('PRODUCT_OPTION_SALE_WAIT');
          } else if (saleStatusType === 'ON_SALE') {
            return window.$t('PRODUCT_OPTION_SELLING');
          } else if (saleStatusType === 'END_SALE') {
            return window.$t('PRODUCT_OPTION_SELL_STOP');
          }
        }, 
        copyOptions: {
            useFormattedValue: true,
        }
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_SALE_SETTING_STATUS',
        name: 'saleSettingStatus',
        align: 'center',
        width: 145,
        formatter: function ({row, value}: any) {
          const saleStatusType = row['saleStatus'];
          const saleSettingStatus = row['saleSettingStatus'];
          if (saleStatusType === 'END_SALE') {
            return '-';
          }
          if (value === 'AVAILABLE_FOR_SALE') {
            return window.$t('DELIVERY_GROUP_TEMPLATE_AVAILABLE_FOR_SALE');
          } else if (value === 'STOP_SELLING') {
            return window.$t('DELIVERY_GROUP_TEMPLATE_STOP_SELLING');
          } else if (value === 'PROHIBITION_SALE') {
            return window.$t('DELIVERY_GROUP_TEMPLATE_PROHIBITION_SALE');
          }
        }, 
        copyOptions: {
            useFormattedValue: true,
        }
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_BUNDLE_DELIVERY',
        name: 'bundleDeliveryAvailable',
        align: 'center',
        width: 145,
        formatter: function ({value}: any) {
          if (value) {
            return window.$t('DELIVERY_GROUP_TEMPLATE_POSSIBLE');
          } else {
            return window.$t('DELIVERY_GROUP_TEMPLATE_IMPOSSIBLE');
          }
        }, 
        copyOptions: {
            useFormattedValue: true,
        }
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_OVERSEA_DELIVERY',
        name: 'overseaDeliveryAvailable',
        align: 'center',
        width: 145,
        formatter: function ({value}: any) {
          if (value) {
            return window.$t('DELIVERY_GROUP_TEMPLATE_POSSIBLE');
          } else {
            return window.$t('DELIVERY_GROUP_TEMPLATE_IMPOSSIBLE');
          }
        }, 
        copyOptions: {
            useFormattedValue: true,
        }
      },
      {
        header: 'DELIVERY_GROUP_TEMPLATE_SALE_DATE',
        name: 'saleYmd',
        align: 'left',
        width: 202,
        formatter: function ({row}: any) {
          return `${row['saleStartDate'].substr(0, 10)} ~ ${row['saleEndDate'].substr(0, 10)}`;
        }, 
        copyOptions: {
            useFormattedValue: true,
        }
      }
    ]
  };
  private tableOption = {
    autoHeight: true,
    haveRigthBtn: false,
    onLoadSearch: false
  };
  created() {
    this.gridProps = i18nInObjectList(this, this.gridProps, 'columns', 'header');
    this.$api.getProductsDetailUrls().then((res) => {
      this.productsDetailUrls = res.data.map(d => {
        d.url = addProductDetailUrlPreview(d.url);
        return d
      });
    });
    this.deliveryTemplateNo = this.$route.query.deliveryTemplateNo as string;

    this.$api.getDeliveryTemplateByNo({params: {templateNo: this.deliveryTemplateNo}}).then((res) => {
      this.template = res.data;
    });
    this.fetchProduct();
  }
  fetchProduct(page: number = 1) {
    const params = {
      deliveryTemplateNo: this.deliveryTemplateNo,
      size: this.gridProps.options.pageOptions.perPage,
      page: page
    };

    this.$api.getProductDeliveryTemplatesByNo({params}).then((res) => {
      this.products = res.data.contents;
      this.gridProps.options.pageOptions.page = page;
      this.gridProps.options.pageOptions.totalCount = res.data.totalCount;
    });
  }
  getProductDetailUrl(mallNo: number) {
    const finded = this.productsDetailUrls.find((productsDetailUrl) => productsDetailUrl.mallNo === mallNo);
    return finded ? finded.url : '';
  }
  close() {
    window.close();
  }
  updated(){
    this.$nextTick(()=>{
      popupResize()
    })
  }
}
